/**
 * Seedable PRNG for the AI (mulberry32). Browser-compatible pure JS.
 *
 * Deterministic: the same seed always yields the same sequence, so an AI
 * created with the same seed plays the same moves given the same sequence
 * of positions. Shared by the sim harness (sim/prng.mjs re-exports this).
 */

/** mulberry32: returns a function producing floats in [0, 1). */
export function mulberry32(seed) {
  let a = seed >>> 0;
  return function next() {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/**
 * Mix several integers into one 32-bit seed (FNV-1a over the bytes).
 * Used to derive independent streams from a base seed, e.g.
 * hashSeed(baseSeed, gameIndex, playerIndex).
 */
export function hashSeed(...nums) {
  let h = 0x811c9dc5;
  for (const n of nums) {
    const x = n >>> 0;
    for (let i = 0; i < 4; i++) {
      h ^= (x >>> (i * 8)) & 0xff;
      h = Math.imul(h, 0x01000193);
    }
  }
  return h >>> 0;
}
